export const UTILITY_OPTIONS = {
  water_supply: [
    { value: 'private_well', en: 'Private Well', es: 'Pozo Privado' },
    { value: 'large_tank', en: 'Large-Capacity Tank', es: 'Tanque de Gran Capacidad' },
    { value: 'rationing', en: 'Rationing', es: 'Racionamiento' },
  ],
  electricity: [
    { value: 'full_generator', en: 'Full Backup Generator', es: 'Generador Respaldo Completo' },
    { value: 'partial_generator', en: 'Partial Generator', es: 'Generador Parcial' },
    { value: 'no_generator', en: 'No Generator', es: 'Sin Generador' },
    { value: 'solar_panels', en: 'Solar Panels', es: 'Paneles Solares' },
    { value: 'wind_turbine', en: 'Wind Turbine', es: 'Turbina Eolica' },
  ],
  connectivity: [
    { value: 'adsl', en: 'ADSL', es: 'ADSL' },
    { value: 'fiber_optic', en: 'Fiber Optic', es: 'Fibra Optica' },
    { value: 'satellite', en: 'Satellite Internet', es: 'Internet Satelital' },
  ],
};

export function getUtilityLabel(category, value, lang = 'en') {
  const opt = UTILITY_OPTIONS[category]?.find(o => o.value === value);
  return opt ? opt[lang] : value;
}
